import { API_URL } from "../../config/connect";

export async function saveDeviceToken(deviceData, forceUpdate = false) {
    // Нормализуем базовый URL, чтобы не было двойных слэшей при REACT_APP_API_URL с `/` на конце
    const normalizedBaseUrl = API_URL.replace(/\/+$/, "");
    const endpoint = `${normalizedBaseUrl}/api/v1/device`;

    try {
        const accessToken = localStorage.getItem("access_token");
        if (!accessToken) {
            throw new Error("Access token is missing");
        }

        // Check if device is already registered to prevent duplicate requests
        // But allow updates if forceUpdate is true (e.g., for token updates)
        const isDeviceRegistered = localStorage.getItem('device_registered') === 'true';
        // Device тілі UserDevices.language ретінде сақталады және бот
        // хабарламаларының тілін сол жерден алады. Егер device бұрын тіркелген
        // болса да, ағымдағы сайт тілі басқа болса (немесе device_language
        // әлі жоқ болса — ескі аккаунт) — тілді жаңартамыз, әйтпесе бот
        // хабарламалары ескі (мысалы ағылшын) тілінде қалып қояды.
        const storedLang = localStorage.getItem('device_language');
        const currentLang = deviceData?.language || null;
        const langNeedsRefresh = isDeviceRegistered &&
            currentLang &&
            (storedLang === null || storedLang !== currentLang);
        if (isDeviceRegistered && !forceUpdate && !langNeedsRefresh) {
            if (process.env.NODE_ENV === 'development') {
                console.debug('Device already registered, skipping API call');
            }
            return { success: true, message: 'Device already registered' };
        }

        // Removed verbose logging - only log in debug mode
        if (process.env.NODE_ENV === 'development') {
            console.debug('Sending device data to backend:', deviceData);
        }

        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
                'Accept-Language': currentLang || 'ru',
            },
            body: JSON.stringify(deviceData)
        });

        if (!response.ok) {
            let errorMessage = `Error: ${response.statusText}`;
            try {
                const errorData = await response.json();

                // Log backend errors in development
                if (process.env.NODE_ENV === 'development') {
                    console.warn('Backend error:', errorData);
                }

                // Try to extract more specific error message
                if (errorData.error) {
                    if (typeof errorData.error === 'object') {
                        errorMessage = JSON.stringify(errorData.error);
                    } else {
                        errorMessage = errorData.error;
                    }
                } else if (errorData.message) {
                    errorMessage = errorData.message;
                } else if (errorData.detail) {
                    errorMessage = errorData.detail;
                }
            } catch (parseError) {
                // Silently handle parse errors
            }
            throw new Error(errorMessage);
        }

        const result = await response.json();
        if (process.env.NODE_ENV === 'development') {
            console.debug('Device token saved successfully');
        }
        // Тілді жергілікті сақтаймыз — келесі жолы ағымдағы сайт тілімен
        // салыстырып, өзгермесе қайта POST жіберместен тоқтаймыз.
        if (currentLang) {
            localStorage.setItem('device_language', currentLang);
        }
        return result;
    } catch (error) {
        if (process.env.NODE_ENV === 'development') {
            const errorMessage = error?.message || error?.toString() || '';
            console.warn('Failed to save device token:', errorMessage);
        }
        throw error;
    }
}
